export default {
      id: "sidebar_speakers-usage",
      viewBox: "0 0 20 20",
      url: "assets/" + "sprite.svg#sidebar_speakers-usage",
      toString: function () {
        return this.url;
      }
    }